<template>
  <BModal
    ref="modalMemo"
    size="lg"
    title="Customer Memo"
    scrollable
    centered
    hide-header
    no-close-on-esc
    no-enforce-focus
    no-close-on-backdrop
    content-class="scrollable-tabs"
    modal-class="full-height modal-no-padding"
    aria-hidden="false"
    role="dialog"
    @shown="eventModalShown"
    @hidden="eventModalHidden"
  >
    <BTabs
      active-nav-item-class="font-weight-bold text-primary"
      nav-class="scrollable-x-tabs no-scrollbar nav-customer-memo-tabs gap-x-1"
      content-class="scrollable"
      pills
    >
      <template #tabs-start>
        <div class="nav-item">
          <div
            class="d-flex align-items-center position-absolute"
            style="padding: 2px 1px; height: 38px;"
          >
            <i
              class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
              style="font-size: 20px;"
            />
          </div>
        </div>
      </template>
      <template #tabs-end>
        <div class="nav-item">
          <div
            class="d-flex align-items-center position-absolute"
            style="right: 20px; padding: 2px 1px; height: 38px;"
          >
            <i
              class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
              style="font-size: 20px;"
            />
          </div>
        </div>
      </template>
      <BTab
        class="p-2 min-h-400px"
      >
        <template #title>
          <div class="text-md-nowrap">
            <i class="fa-xl fad fa-file-lines" />
            <b class="is-tab-active ml-1">
              Details
            </b>
          </div>
        </template>

        <ValidationObserver
          ref="formMemo"
        >
          <form
            role="form"
            novalidate
            @submit.prevent
          >
            <BRow>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Code"
                  label-for="fCustomerCode"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fCustomerCode"
                    v-model="customer.customer_code"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Cluster"
                  label-for="fCluster"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fCluster"
                    v-model="customer.cluster_name"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Customer"
                  label-for="fCustomerName"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fRemarks"
                    v-model="customer.customer_name"
                    rows="2"
                    max-rows="4"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Contact Person"
                  label-for="fContactPerson"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fContactPerson"
                    v-model="customer.contact_person"
                    placeholder="no selected customer"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Address"
                  label-for="fAddress"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fAddress"
                    v-model="customer.address"
                    rows="2"
                    max-rows="12"
                    placeholder="no address"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Customer Memo"
                  label-for="fCustomerMemo"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fCustomerMemo"
                    v-model="formMemo.customer_memo_name"
                    rows="2"
                    max-rows="12"
                    placeholder="no customer memo"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Month"
                  label-for="fMonth"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fMonth"
                    v-model="formMemo.schedule"
                    placeholder="no selected month"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
                md="3"
              >
                <BFormGroup
                  label="Event Date"
                  label-for="fEventDate"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fEventDate"
                    v-model="formMemo.event_date"
                    type="date"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <BCol
                cols="6"
                md="3"
              >
                <BFormGroup
                  label="Is Signed?"
                  label-for="fIsSigned"
                  :label-class="`font-weight-bolder text-${Number(formMemo.is_signed) === 1 ? 'primary' : 'danger'}`"
                  class="mb-2"
                >
                  <BFormSelect
                    id="fIsSigned"
                    v-model="formMemo.is_signed"
                    :options="options.yesOrNos"
                    disabled
                  >
                    <template #first>
                      <BFormSelectOption
                        value=""
                        disabled
                        v-text="' - - select here - - '"
                      />
                    </template>
                  </BFormSelect>
                </BFormGroup>
              </BCol>

              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Remarks"
                  label-for="fRemarks"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormTextarea
                    id="fRemarks"
                    v-model="formMemo.remarks"
                    rows="5"
                    max-rows="12"
                    maxlength="1000"
                    placeholder="no remarks"
                    disabled
                  />
                </BFormGroup>
              </BCol>
            </BRow>

          </form>
        </ValidationObserver>
      </BTab>

      <BTab
        class="p-2 min-h-400px"
      >
        <template #title>
          <div class="text-md-nowrap">
            <i class="fa-xl fad fa-paperclip" />
            <b class="is-tab-active ml-1">
              Attachments
            </b>
          </div>
        </template>
        <Attachment
          ref="attachmentUploader"
          valid-id=""
          :loading="state.busy"
          :path="formMemo.attachment_path"
          :files="formMemo.attachments"
          :deleted-files="formMemo.deleted_files"
          :show-uploader="false"
        />
      </BTab>
    </BTabs>
    <template #modal-footer="{ cancel }">
      <div class="d-flex justify-content-between gap-2 w-100">
        <div />
        <BButton
          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Close
        </BButton>
      </div>
    </template>

  </BModal>
</template>
<script>
import { mapGetters } from 'vuex'
import { find } from 'lodash'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'
import moment from 'moment'

import Attachment from '@/views/accountant/customer-memos/components/Attachment.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

export default {
  name: 'AccountantCustomerMemosView',

  components: {
    Attachment
  },

  mixins: [
    MxMisc,
    MxFormatter
  ],

  emits: [
    'update:row',
    'update:rows'
  ],

  data () {
    return {
      geoLocationId: null,
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        verifying: false
      },
      options: {
        yesOrNos: [
          { value: 1, text: 'Yes' },
          { value: 0, text: 'No' }
        ]
      },
      customer: {
        cluster_name: '',
        customer_code: '',
        customer_name: '',
        contact_person: '',
        address: ''
      },
      formMemoValidation: {
        rangeDate: {
          min: moment().subtract(2, 'years').startOf('year').format('YYYY-MM-DD'),
          max: moment().endOf('month').format('YYYY-MM-DD')
        }
      },
      formMemo: {
        id: '',
        schedule: '',
        event_date: '',
        remarks: '',
        attachment_path: '',
        customer_memo_name: '',
        attachments: [],
        status: 'Closed',
        verification_status: '',
        is_signed: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    MMemoTitle () {
      return 'View Customer Memo'
    }
  },

  watch: {
    'selected.fsOfficer' (officer) {
      this.formMemo.assignee_id = officer?.id || ''
    },

    'selected.customer' (customer) {
      this.formMemo.customer_id = customer?.id || ''
    }
  },

  methods: {

    vTabEventDetails () {
      if (this.$refs.formMemo) {
        const formMemoErrors = this.$refs.formMemo.errors

        return Object.keys(formMemoErrors).some(
          errorKey => formMemoErrors[errorKey]?.length > 0
        )
      }

      return false
    },

    vTabAttachments () {
      if (this.$refs.attachmentUploader) {
        const formDocument = this.$refs.attachmentUploader.$refs.formDocument

        if (formDocument) {
          return Object.keys(formDocument.errors).some(
            errorKey => formDocument.errors[errorKey]?.length > 0
          )
        }
      }

      return false
    },

    viewMemo (memo) {
      this.state.verifying = false

      const dateFormat = 'YYYY-MM-DD'

      const minDay = moment(memo.schedule).subtract(2, 'years').startOf('year')
      const maxDay = moment(memo.schedule).add(50, 'years').endOf('year')

      this.formMemoValidation.rangeDate = Object.assign(this.formMemoValidation.rangeDate, {
        min: minDay.startOf('month').format(dateFormat),
        max: maxDay.endOf('month').format(dateFormat)
      })

      const clusters = memo.assignee?.clusters || []
      const cluster = find(clusters, { id: memo.customer?.cluster_id }) || {}

      this.customer = Object.assign(this.customer, {
        cluster_name: cluster?.cluster_name || '',
        customer_code: memo.customer?.customer_code || '',
        customer_name: memo.customer?.customer_name || '',
        contact_person: memo.customer?.contact_person || '',
        address: memo.customer?.address || ''
      })

      this.formMemo = Object.assign(this.formMemo, {
        id: memo.id,
        customer_id: memo.customer_id,
        customer_memo_name: memo?.memo?.customer_memo_name || '',
        schedule: memo.schedule,
        event_date: memo.event_date,
        is_signed: memo.is_signed,
        attachment_path: memo?.attachment_path || '',
        attachments: memo?.attachments || [],
        remarks: memo?.remarks || '',
        status: memo?.status,
        verification_status: memo?.verification_status
      })

      this.$refs.modalMemo.show()
    },

    eventModalHidden () {
      this.detachArrowScroller('.nav-customer-memo-tabs')
    },

    eventModalShown () {
      this.attachArrowScroller('.nav-customer-memo-tabs')
    }
  }
}
</script>
